var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgProgressIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#6D6970",
  fillRule: "evenodd",
  d: "M15.665 10a5.667 5.667 0 1 1-11.333 0 5.667 5.667 0 0 1 11.333 0m1 0a6.667 6.667 0 1 1-13.333 0 6.667 6.667 0 0 1 13.333 0M10.5 6.668a.5.5 0 0 0-1 0v3.25a.7.7 0 0 0 .205.496l2.441 2.441.209.209a.5.5 0 1 0 .707-.708l-.209-.208L10.5 9.794z",
  clipRule: "evenodd"
})));
export default SvgProgressIcon;